import { render, staticRenderFns } from "./v-attach-list-certification.vue?vue&type=template&id=7a4dd4c3&"
import script from "./v-attach-list-certification.vue?vue&type=script&lang=js&"
export * from "./v-attach-list-certification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports